import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentIntegrationConnectorDefinition on IntgConnectorDefinition {
    id
    name
    imports {
      api {
        path
        query {
          name
          value
        }
        recordsPath
        responseType
        pagination
      }
      mapping {
        modelId
        fields {
          source
          target
          reference {
            entityId
          }
        }
      }
    }
  }
`

/**
 * Pagination is carried by `AWSJSON`, which arrives as a JSON string rather
 * than as an object, so it is parsed back into the entity here.
 */
const PAGINATION = graphql.transformers.OUT.json()

export const TRANSFORMER = graphql.transformers.OUT.custom<
  graphql.schema.FragmentIntegrationConnectorDefinitionFragment,
  ents.core.integrations.Connector.Definition
>(definition => {
  const transformed: unknown = {
    id: definition.id,
    imports: definition.imports.map(definitionImport => ({
      api: {
        pagination: PAGINATION.getEntityFrom(definitionImport.api.pagination),
        path: definitionImport.api.path,
        query: definitionImport.api.query
          ? Object.fromEntries(
              definitionImport.api.query.map(({ name, value }) => [
                name,
                value,
              ]),
            )
          : undefined,
        recordsPath: definitionImport.api.recordsPath ?? undefined,
        responseType:
          definitionImport.api.responseType ===
          graphql.schema.IntgApiResponseType.Array
            ? 'array'
            : 'object',
      },
      mapping: {
        fields: definitionImport.mapping.fields.map(field => ({
          reference: field.reference
            ? { entityId: field.reference.entityId }
            : undefined,
          source: field.source,
          target: field.target,
        })),
        modelId: definitionImport.mapping.modelId,
      },
    })),
    name: definition.name,
  }
  ents.core.integrations.Connector.Definition.assertIsDefinition(transformed)
  return transformed
})
